import React from 'react';
import classNames from 'classnames';

import { Select, Radio } from 'antd';

import ColorDisplay from '../color-display/color-display.js';

import ColorStore from '../../stores/color';

import './color-editor.less';

import { generate } from '@ant-design/colors';
//const colors = generate( value );

export default class ColorEditor extends React.Component {
    state = {
        colors: []
    };

    static getDerivedStateFromProps( props, state ) {
        if (
            state.colorStore &&
            state.colorStore.key !== new ColorStore( props ).key
        ) {
            return {
                colorStore: null
            };
        }
        return null;
    }

    componentDidMount() {
        this.load();
    }
    componentWillUnmount() {
        const { colorStore } = this.state;

        if ( colorStore ) {
            colorStore.colorsChange.off( this.handleColorsChange );
        }
    }
    componentDidUpdate( prevProps, prevState ) {
        const { loading, colorStore } = this.state;

        if ( !colorStore && !loading ) {
            this.load();
        }
    }

    render() {
        const {
            onChange,
            value,
            className,
            allowClear,
            allowModifications,
            readOnly,
            disabled
        } = this.props;

        const { colors } = this.state;

        return (
            <span className={ classNames( 'color-editor', className ) }>
                <Select
                    allowClear={ allowClear }
                    value={ value }
                    onChange={ onChange }
                    readOnly={ readOnly }
                    disabled={ disabled }
                >
                {
                    /*
                        If the color isn't in the colors, add the option
                        this can happen if there is a fallback
                    */
                    ( value && !colors.find( color => color.hex === value ) ) &&
                    <Select.Option value={ value }>
                        <ColorDisplay
                            value={ value }
                            text={ value }
                        />
                    </Select.Option>
                }
                {
                    colors.filter( color => !!color.hex ).map( color => (
                        <Select.Option
                            key={ color.hex }
                            value={ color.hax }
                        >
                            <div>
                                <div className="color-option-container">
                                    <ColorDisplay
                                        value={ color.hex }
                                        text={ color.hex }
                                    />
                                    {
                                        allowModifications && (
                                            <div className="tint-shade-container">
                                                <Radio.Group defaultValue={ null } buttonStyle="solid">
                                                    {
                                                        color.tintsAndShades.map( ( hex, index ) => (
                                                            <Radio.Button key={ hex } value={ this.getTintShadeValue( index ) }>
                                                                <ColorDisplay value={ hex } />
                                                            </Radio.Button>
                                                        ) )
                                                    }
                                                </Radio.Group>
                                            </div>
                                        )
                                    }
                                    </div>
                                </div>
                        </Select.Option>
                    ) )
                }

                </Select>
            </span>
        );
    }

    handleColorsChange = ( { colors } ) => {
        this.setState( {
            colors: colors.map( c => ( {
                ...c,
                tintsAndShades: generate( c.hex )
            } ) )
        } );
    };

    getTintShadeValue = ( index ) => {
        if ( index < 5 ) {
            return `tint(${ 5 - index })`;
        } else if ( index > 5 ) {
            return `shade(${ index - 5 })`;
        } else {
            return null;
        }
    };

    load = async () => {
        let { colorStore } = this.state;

        if ( colorStore ) {
            colorStore.colorsChange.off( this.handleColorsChange );
        }

        colorStore = new ColorStore( this.props );
        colorStore.colorsChange.on( this.handleColorsChange );

        this.setState( {
            loading: true,
            colorStore
        } );

        try {
            const { colors } = await colorStore.getColors();



            this.setState( {
                loading: false,
                colors: colors.map( c => ( {
                    ...c,
                    tintsAndShades: generate( c.hex )
                } ) )
            } );
        } catch ( { errors } ) {
            this.setState( {
                loading: false,
                loadingErrors: errors
            } );
        }
    };
}
